import { DialogActions as MuiDialogActions, withStyles } from '@material-ui/core';

const DialogActions = withStyles((theme) => ({
  root: {
    padding: '12px 8px',
    margin: '0 16px',
    justifyContent: 'space-between',
    borderTop: `1px solid ${theme.colors.greyE8}`,
  },
  spacing: {
    '& > * + *': {
      marginLeft: 16,
    },
  },
}))(MuiDialogActions);

export default DialogActions;
